export default __webpack_public_path__ + "678a13b97b6f087d2af38aac4ab8c535.png";